/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const overrideUpdateBodyStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const overrideUpdateBodyEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const overrideUpdateBodySubstituteUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const overrideUpdateBodyReasonMax = 1000;

export const overrideUpdateBodyExpectedVersionExclusiveMin = 0;
export const overrideUpdateBodyExpectedVersionMax = 9007199254740991;

export const OverrideUpdateBody = zod.object({
  start: zod.iso.datetime({ offset: true }).regex(overrideUpdateBodyStartRegExp).optional(),
  end: zod.iso.datetime({ offset: true }).regex(overrideUpdateBodyEndRegExp).optional(),
  substituteUserId: zod.uuid().regex(overrideUpdateBodySubstituteUserIdRegExp).optional(),
  reason: zod.string().max(overrideUpdateBodyReasonMax).optional(),
  expectedVersion: zod
    .int()
    .gt(overrideUpdateBodyExpectedVersionExclusiveMin)
    .max(overrideUpdateBodyExpectedVersionMax),
});

export type OverrideUpdateBody = zod.input<typeof OverrideUpdateBody>;
export type OverrideUpdateBodyOutput = zod.output<typeof OverrideUpdateBody>;
